// Shared Rock Chicks Productions email signature (email-safe, table + inline CSS).
// Uses the black-on-white logo since email backgrounds are typically white.

export const SIGNATURE = {
  name: "Marta Pérez Pagès",
  role: "Live Events & Touring — Rock Chicks Productions",
  phone: "+34 610 360 751",
  phoneHref: "+34610360751",
  email: "marta@rockchicksproductions.com",
  website: "rockchicksproductions.com",
  websiteHref: "https://rockchicksproductions.com",
  location: "Barcelona, Spain",
  logo:
    "https://customer-assets-v7afamib.emergentagent.net/job_rock-expertise-hub/artifacts/ox1qh6pl_image.png",
};

export const buildSignatureHTML = (s = SIGNATURE) => `
<table cellpadding="0" cellspacing="0" border="0" style="font-family:Arial,Helvetica,sans-serif;border-collapse:collapse;">
  <tr>
    <td style="padding:0 24px 0 0;border-right:3px solid #b533ff;vertical-align:middle;">
      <img src="${s.logo}" width="170" alt="Rock Chicks Productions" style="display:block;border:0;outline:none;" />
    </td>
    <td style="padding-left:24px;vertical-align:middle;">
      <div style="font-size:18px;font-weight:bold;color:#111111;">${s.name}</div>
      <div style="font-size:12px;color:#b533ff;font-weight:bold;letter-spacing:1px;text-transform:uppercase;margin:3px 0 10px;">${s.role}</div>
      <div style="font-size:13px;color:#333333;line-height:1.7;">
        <a href="tel:${s.phoneHref}" style="color:#333333;text-decoration:none;">${s.phone}</a><br/>
        <a href="mailto:${s.email}" style="color:#333333;text-decoration:none;">${s.email}</a><br/>
        <a href="${s.websiteHref}" style="color:#b533ff;text-decoration:none;font-weight:bold;">${s.website}</a>
        <span style="color:#999999;">&nbsp;·&nbsp;</span>${s.location}
      </div>
    </td>
  </tr>
</table>`.trim();
